<section class="popup-wrapper">
    <article class="popup-header">
        <div class="header-gif">
            <img class="switch-img" src="../../../../../assets/gif/finzy-flex/switchOffForBolt.svg" alt="switch-on"/>
        </div>
        <div class="header-label">
            <span>Switch Off Bolt</span>
        </div>
        <div class="header-content">
            <span *ngIf="addMoney">
                Switch Off <strong class="dark-text">Bolt</strong> to add funds
            </span>
            <span *ngIf="!addMoney">
                Switch Off <strong class="dark-text">Bolt</strong> to start finzyFlex investment
            </span>
        </div>
    </article>
    <article class="popup-body">
        <span *ngIf="addMoney" class="body-text">
            To add funds to your investment wallet, your existing auto investment option(<strong class="dark-text">finzyBolt</strong>) has to be switched off.
        </span>
        <span *ngIf="!addMoney" class="body-text">
            To invest in a <strong class="dark-text">finzyFlex</strong> or enable <strong class="dark-text">Swift</strong>, your existing auto investment option(<strong class="dark-text">finzyBolt</strong>) has to be switched off. 
        </span>
    </article>
    <article class="popup-footer">
        <button class="outline-btn" (click)="onClickClose()">Later</button>
        <button class="normal-btn"(click)="onClickBoltOff(boltEnabled)">Switch Off</button>
    </article>
</section>